export { CallState } from '../../features/call/call.types';

import {
  setIsChatOpen,
  setActiveUserAccordionIdById,
  setIsPictureInPictureStarted,
} from '../../features/uiState/uiState.slice';
import { useAppDispatch } from '../useReduxToolkit';

type Return = {
  setChatOpen: (value: boolean) => void;
  setActiveUserAccordionId: (value: string | undefined) => void;
  setPictureInPictureStarted: (value: boolean) => void;
};

export const useUIState = (): Return => {
  const dispatch = useAppDispatch();

  const setChatOpen = (value: boolean): void => {
    dispatch(setIsChatOpen(value));
  };

  const setActiveUserAccordionId = (value: string | undefined): void => {
    dispatch(setActiveUserAccordionIdById(value));
  };

  const setPictureInPictureStarted = (value: boolean): void => {
    dispatch(setIsPictureInPictureStarted(value));
  };

  return {
    setChatOpen,
    setActiveUserAccordionId,
    setPictureInPictureStarted,
  };
};
